var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('el-aside',{staticStyle:{"height":"100%","width":"100%"}},[_c('MenuIndex')],1),_c('el-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }